// BabyMobile.ca — custom order configurator: live selection state + price estimate
(function () {
  var root = document.querySelector('[data-rd-configurator]');
  if (!root) return;

  var BASE_PRICE = 200;
  var CHAR_PRICE = 15;
  var NAME_PRICE = 20;
  var RUSH_PRICE = 40;
  var LETTER_PRICE = 8;
  var CHAR_INCLUDED = 3;
  var MAX_PALETTE_COLORS = 5;
  var FELT_COLORS = window.RD_FELT_COLORS || [];
  var DEFAULT_NAMES = ['Pink', 'Baby Blue', 'Mellow Yellow', 'Spring Green', 'Lavender', 'Cream', 'Peachy Pink', 'Sage'];

  var state = {
    kind: 'mobile',
    ref: null, // { handle, name, img, price } or null
    theme: null,
    size: null,
    bannerStyle: null,
    word: '',
    letterColors: {},
    paletteColors: [], // [{ color: {name, hex}, note: '' }]
    chars: CHAR_INCLUDED,
    addons: { name: false, rush: false }
  };

  var kindGrid = root.querySelector('[data-cfg-kind-grid]');
  var refGrids = root.querySelectorAll('[data-cfg-ref-grid]');
  var refMoreButtons = root.querySelectorAll('[data-cfg-ref-more]');
  var styleGrid = root.querySelector('[data-cfg-style-grid]');
  var addColorBtn = root.querySelector('[data-cfg-add-color]');
  var colorListEl = root.querySelector('[data-cfg-color-list]');
  var stepNumEls = {
    colors: root.querySelector('[data-cfg-step="colors"]'),
    details: root.querySelector('[data-cfg-step="details"]'),
    yourdetails: root.querySelector('[data-cfg-step="yourdetails"]')
  };
  var wordInput = root.querySelector('[data-cfg-word-input]');
  var letterTilesEl = root.querySelector('[data-cfg-letter-tiles]');
  var letterCountEl = root.querySelector('[data-cfg-letter-count]');
  if (letterTilesEl) {
    letterTilesEl.setAttribute('role', 'group');
    letterTilesEl.setAttribute('aria-label', 'Banner preview');
  }
  var customizeTitleEl = root.querySelector('[data-cfg-customize-title]');

  var summaryKicker = root.querySelector('[data-cfg-summary-kicker]');
  var summaryTheme = root.querySelector('[data-cfg-summary-theme]');
  var summaryRefWrap = root.querySelector('[data-cfg-summary-ref]');
  var summaryRefImg = root.querySelector('[data-cfg-summary-ref-img]');
  var summaryRefName = root.querySelector('[data-cfg-summary-ref-name]');
  var summaryLines = root.querySelector('[data-cfg-summary-lines]');
  var summaryTotal = root.querySelector('[data-cfg-summary-total]');

  var hiddenFields = {
    kind: root.querySelector('[data-cfg-field="kind"]'),
    reference: root.querySelector('[data-cfg-field="reference"]'),
    theme: root.querySelector('[data-cfg-field="theme"]'),
    size: root.querySelector('[data-cfg-field="size"]'),
    word: root.querySelector('[data-cfg-field="word"]'),
    bstyle: root.querySelector('[data-cfg-field="bstyle"]'),
    palette: root.querySelector('[data-cfg-field="palette"]'),
    letter_colors: root.querySelector('[data-cfg-field="letter_colors"]'),
    chars: root.querySelector('[data-cfg-field="chars"]'),
    name_addon: root.querySelector('[data-cfg-field="name_addon"]'),
    rush_addon: root.querySelector('[data-cfg-field="rush_addon"]'),
    estimate: root.querySelector('[data-cfg-field="estimate"]'),
    summary: root.querySelector('[data-cfg-field="summary"]')
  };

  function money(n) {
    return '$' + n;
  }

  function isBanner() {
    return state.kind === 'banner';
  }

  function letterInfo() {
    var word = (state.word || '').toUpperCase();
    var letters = word.replace(/[^A-Z0-9]/g, '').length;
    return { word: word, letters: letters };
  }

  function defaultLetterColor(i) {
    var name = DEFAULT_NAMES[i % DEFAULT_NAMES.length];
    for (var j = 0; j < FELT_COLORS.length; j++) {
      if (FELT_COLORS[j].name === name) return FELT_COLORS[j];
    }
    return FELT_COLORS[0] || { name: '', hex: '#EFEDF9' };
  }

  function letterColorAt(i) {
    return state.letterColors[i] || defaultLetterColor(i);
  }

  function letterColorsText() {
    var li = letterInfo();
    return li.word.split('').map(function (ch, i) {
      return ch.toUpperCase() + ':' + letterColorAt(i).name;
    }).join(', ');
  }

  function paletteColorsText() {
    return state.paletteColors.map(function (p) {
      return p.note ? (p.color.name + ' (' + p.note + ')') : p.color.name;
    }).join(', ');
  }

  function calcPrice() {
    if (isBanner()) {
      var li = letterInfo();
      return li.letters * LETTER_PRICE;
    }
    var sizePrice = state.size ? parseInt(state.size.getAttribute('data-cfg-size-price'), 10) || 0 : 0;
    var charsExtra = Math.max(0, state.chars - CHAR_INCLUDED) * CHAR_PRICE;
    var nameAdd = state.addons.name ? NAME_PRICE : 0;
    var rushAdd = state.addons.rush ? RUSH_PRICE : 0;
    return BASE_PRICE + sizePrice + charsExtra + nameAdd + rushAdd;
  }

  function buildSummaryText(estimate, extras) {
    var lines = [];
    lines.push('Making: ' + (isBanner() ? 'Banner & garland' : 'Baby mobile'));
    lines.push('Reference: ' + (state.ref ? state.ref.name : 'Start from scratch'));

    if (isBanner()) {
      var li = letterInfo();
      lines.push('Banner word: ' + (li.word || 'Not set yet'));
      lines.push('Style: ' + (state.bannerStyle ? state.bannerStyle.getAttribute('data-cfg-style') : 'Not chosen yet'));
      if (li.letters) lines.push('Letter colours: ' + letterColorsText());
    } else {
      lines.push('Colour palette: ' + (state.paletteColors.length ? paletteColorsText() : 'None selected'));
    }

    lines.push('Estimate: $' + estimate + ' (advisory — firm quote arrives with the sketch)');

    if (extras) {
      if (extras.babyName) lines.push('Baby\'s name: ' + extras.babyName);
      if (extras.neededBy) lines.push('Needed by: ' + extras.neededBy);
      if (extras.vision) lines.push('', 'Customer\'s vision:', extras.vision);
    }
    return lines.join('\n');
  }

  function renderLetterTiles() {
    if (!letterTilesEl) return;
    if (window.RDCloseColorPicker) window.RDCloseColorPicker();
    var li = letterInfo();
    letterTilesEl.innerHTML = '';
    state.word.slice(0, 12).split('').forEach(function (ch, i) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'rd-cfg-letter-tile';
      tile.style.background = letterColorAt(i).hex;
      tile.style.setProperty('--i', i);
      tile.title = letterColorAt(i).name + ' — tap to change this letter\'s colour';
      tile.setAttribute('aria-label', 'Letter ' + (ch === ' ' ? 'space' : ch.toUpperCase()) + ', colour ' + letterColorAt(i).name + ' — tap to change');
      tile.textContent = ch === ' ' ? '·' : ch.toUpperCase();
      tile.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!window.RDOpenColorPicker) return;
        window.RDOpenColorPicker(tile, function (c) {
          state.letterColors[i] = c;
          tile.style.background = c.hex;
          tile.title = c.name + ' — tap to change this letter\'s colour';
          tile.setAttribute('aria-label', 'Letter ' + (ch === ' ' ? 'space' : ch.toUpperCase()) + ', colour ' + c.name + ' — tap to change');
          render();
        });
      });
      letterTilesEl.appendChild(tile);
    });
    if (letterCountEl) letterCountEl.textContent = li.letters;
  }

  function render() {
    var banner = isBanner();
    var li = letterInfo();
    var estimate = calcPrice();

    if (customizeTitleEl) customizeTitleEl.textContent = banner ? 'Design your banner' : 'Choose the details';
    if (summaryKicker) summaryKicker.textContent = banner ? 'Your custom banner' : 'Your custom mobile';

    var themeText;
    if (banner) {
      themeText = (li.word || 'Your') + ' banner';
    } else {
      themeText = state.theme ? state.theme.getAttribute('data-cfg-theme') + ' mobile' : 'Your custom mobile';
    }
    if (summaryTheme) summaryTheme.textContent = themeText;

    if (summaryRefWrap) {
      if (state.ref) {
        summaryRefWrap.hidden = false;
        if (summaryRefImg) summaryRefImg.src = state.ref.img;
        if (summaryRefName) summaryRefName.textContent = state.ref.name;
      } else {
        summaryRefWrap.hidden = true;
      }
    }

    if (summaryLines) {
      summaryLines.innerHTML = '';
      var rows = [];

      if (banner) {
        rows.push({ label: (li.word || 'Your word') + ' · ' + li.letters + ' letters', value: money(li.letters * LETTER_PRICE), active: false });
        rows.push({ label: 'Per letter', value: money(LETTER_PRICE), active: false });
        if (state.bannerStyle) {
          rows.push({ label: 'Style', value: state.bannerStyle.getAttribute('data-cfg-style'), active: false });
        }
        if (li.letters) {
          rows.push({ label: 'Letter colours', value: letterColorsText(), active: false });
        }
      } else if (state.paletteColors.length) {
        rows.push({ label: 'Colour palette', value: paletteColorsText(), active: false });
      }

      rows.forEach(function (row) {
        var line = document.createElement('div');
        line.className = 'rd-cfg-summary-line';
        var label = document.createElement('span');
        label.className = 'rd-cfg-summary-line-label';
        label.textContent = row.label;
        var value = document.createElement('span');
        value.className = 'rd-cfg-summary-line-value' + (row.active ? ' is-active' : '');
        value.textContent = row.value;
        line.appendChild(label);
        line.appendChild(value);
        summaryLines.appendChild(line);
      });
    }

    if (summaryTotal) summaryTotal.textContent = money(estimate);

    if (hiddenFields.kind) hiddenFields.kind.value = banner ? 'Banner & garland' : 'Baby mobile';
    if (hiddenFields.reference) hiddenFields.reference.value = state.ref ? state.ref.name : 'Start from scratch';
    if (hiddenFields.theme) hiddenFields.theme.value = banner ? '' : (state.theme ? state.theme.getAttribute('data-cfg-theme') : '');
    if (hiddenFields.size) hiddenFields.size.value = banner ? '' : (state.size ? state.size.getAttribute('data-cfg-size-name') : '');
    if (hiddenFields.word) hiddenFields.word.value = banner ? li.word : '';
    if (hiddenFields.bstyle) hiddenFields.bstyle.value = banner && state.bannerStyle ? state.bannerStyle.getAttribute('data-cfg-style') : '';
    if (hiddenFields.palette) hiddenFields.palette.value = banner ? '' : paletteColorsText();
    if (hiddenFields.letter_colors) hiddenFields.letter_colors.value = banner ? letterColorsText() : '';
    if (hiddenFields.chars) hiddenFields.chars.value = '';
    if (hiddenFields.name_addon) hiddenFields.name_addon.value = 'No';
    if (hiddenFields.rush_addon) hiddenFields.rush_addon.value = 'No';
    if (hiddenFields.estimate) hiddenFields.estimate.value = '$' + estimate;
    if (hiddenFields.summary) hiddenFields.summary.value = buildSummaryText(estimate);
  }

  function selectRefInGrids(handle) {
    refGrids.forEach(function (grid) {
      grid.querySelectorAll('.rd-cfg-ref-tile, [data-cfg-ref-scratch]').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      if (handle) {
        var match = grid.querySelector('[data-cfg-ref="' + handle + '"]');
        if (match) match.classList.add('is-selected');
      } else {
        var scratch = grid.querySelector('[data-cfg-ref-scratch]');
        if (scratch) scratch.classList.add('is-selected');
      }
    });
  }

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function updateStepNumbers() {
    var n = 1;
    if (isBanner()) {
      n++;
      if (stepNumEls.details) stepNumEls.details.textContent = pad2(n);
    } else {
      n++;
      if (stepNumEls.colors) stepNumEls.colors.textContent = pad2(n);
    }
    n++;
    if (stepNumEls.yourdetails) stepNumEls.yourdetails.textContent = pad2(n);
  }

  function setKind(kind) {
    state.kind = kind;
    root.setAttribute('data-cfg-kind', kind);
    if (kindGrid) {
      kindGrid.querySelectorAll('.rd-cfg-kind-tile').forEach(function (t) {
        t.classList.toggle('is-selected', t.getAttribute('data-cfg-kind-option') === kind);
      });
    }
    updateStepNumbers();
  }

  function expandRefGrid(kind) {
    var grid = root.querySelector('[data-cfg-ref-grid="' + kind + '"]');
    var btn = root.querySelector('[data-cfg-ref-more="' + kind + '"]');
    if (grid) grid.classList.add('is-expanded');
    if (btn) btn.textContent = 'Show fewer pieces';
  }

  function setRefByHandle(handle) {
    var grid = root.querySelector('[data-cfg-ref-grid="' + state.kind + '"]');
    if (!grid) return;
    if (!handle) {
      state.ref = null;
      selectRefInGrids(null);
      return;
    }
    var tile = grid.querySelector('[data-cfg-ref="' + handle + '"]');
    if (!tile) return;
    state.ref = {
      handle: handle,
      name: tile.getAttribute('data-cfg-ref-name'),
      img: tile.getAttribute('data-cfg-ref-img'),
      price: tile.getAttribute('data-cfg-ref-price')
    };
    selectRefInGrids(handle);
    expandRefGrid(state.kind);
  }

  if (kindGrid) {
    kindGrid.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-cfg-kind-option]');
      if (!tile) return;
      var kind = tile.getAttribute('data-cfg-kind-option');
      if (kind === state.kind) return;
      setKind(kind);
      state.ref = null;
      selectRefInGrids(null);
      render();
    });
  }

  refGrids.forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      var scratch = e.target.closest('[data-cfg-ref-scratch]');
      if (scratch) {
        state.ref = null;
        selectRefInGrids(null);
        render();
        return;
      }
      var tile = e.target.closest('[data-cfg-ref]');
      if (!tile) return;
      setRefByHandle(tile.getAttribute('data-cfg-ref'));
      render();
    });
  });

  refMoreButtons.forEach(function (btn) {
    var kind = btn.getAttribute('data-cfg-ref-more');
    var grid = root.querySelector('[data-cfg-ref-grid="' + kind + '"]');
    var defaultLabel = btn.textContent;
    btn.addEventListener('click', function () {
      if (!grid) return;
      var expanded = grid.classList.toggle('is-expanded');
      btn.textContent = expanded ? 'Show fewer pieces' : defaultLabel;
    });
  });

  if (styleGrid) {
    styleGrid.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-cfg-style]');
      if (!tile) return;
      styleGrid.querySelectorAll('.rd-cfg-tile').forEach(function (t) { t.classList.remove('is-selected'); });
      tile.classList.add('is-selected');
      state.bannerStyle = tile;
      render();
    });
  }

  function renderColorList() {
    if (!colorListEl) return;
    if (window.RDCloseColorPicker) window.RDCloseColorPicker();
    colorListEl.innerHTML = '';
    state.paletteColors.forEach(function (entry, i) {
      var row = document.createElement('div');
      row.className = 'rd-cfg-color-row';

      var swatch = document.createElement('span');
      swatch.className = 'rd-cfg-color-row-swatch';
      swatch.style.background = entry.color.hex;

      var name = document.createElement('span');
      name.className = 'rd-cfg-color-row-name';
      name.textContent = entry.color.name;

      var note = document.createElement('input');
      note.type = 'text';
      note.className = 'rd-cfg-color-row-note';
      note.placeholder = 'e.g. the mane, wings, or where to use this colour';
      note.value = entry.note || '';
      note.addEventListener('input', function () {
        entry.note = note.value;
        render();
      });

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'rd-cfg-color-row-remove';
      removeBtn.setAttribute('aria-label', 'Remove ' + entry.color.name);
      removeBtn.textContent = '×';
      removeBtn.addEventListener('click', function () {
        state.paletteColors.splice(i, 1);
        renderColorList();
        render();
      });

      row.appendChild(swatch);
      row.appendChild(name);
      row.appendChild(note);
      row.appendChild(removeBtn);
      colorListEl.appendChild(row);
    });
    updateAddColorBtn();
  }

  function updateAddColorBtn() {
    if (!addColorBtn) return;
    var full = state.paletteColors.length >= MAX_PALETTE_COLORS;
    addColorBtn.disabled = full;
    addColorBtn.textContent = full ? 'Maximum 5 colours' : '+ Add a colour';
  }

  if (addColorBtn) {
    addColorBtn.addEventListener('click', function () {
      if (state.paletteColors.length >= MAX_PALETTE_COLORS) return;
      if (!window.RDOpenColorPicker) return;
      window.RDOpenColorPicker(addColorBtn, function (c) {
        state.paletteColors.push({ color: c, note: '' });
        renderColorList();
        render();
      });
    });
  }

  if (wordInput) {
    wordInput.addEventListener('input', function () {
      state.word = wordInput.value;
      renderLetterTiles();
      render();
    });
  }


  var form = document.getElementById('rd-custom-order-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var missingWord = isBanner() && letterInfo().letters === 0;
      if (missingWord) {
        e.preventDefault();
        window.alert('Please enter the word or name for your banner before requesting your sketch.');
        return;
      }
      var estimate = calcPrice();
      var babyNameField = form.querySelector('[name="contact[Baby\'s name]"]');
      var neededByField = form.querySelector('[name="contact[Needed by]"]');
      var visionField = form.querySelector('[name="contact[Your vision]"]');
      if (hiddenFields.summary) {
        hiddenFields.summary.value = buildSummaryText(estimate, {
          babyName: babyNameField ? babyNameField.value : '',
          neededBy: neededByField ? neededByField.value : '',
          vision: visionField ? visionField.value : ''
        });
      }
    });
  }

  // Pre-fill from a product page's "Personalize it" link: ?ref=<handle>&kind=mobile|banner
  var params = new URLSearchParams(window.location.search);
  var urlRef = params.get('ref');
  var urlKind = params.get('kind');
  if (urlKind === 'banner' || urlKind === 'mobile') {
    setKind(urlKind);
  }
  if (urlRef) {
    setRefByHandle(urlRef);
  }

  updateStepNumbers();
  renderColorList();
  renderLetterTiles();
  render();
})();
